import React from 'react';
import logoText from '../../../../assets/DasboardIcons/logo-text.png';
import './UnauthorizedView.css';

const UnauthorizedView = ({ onLogin }) => {
    return (
        <div className="unauthorized-view">
            <div className="unauthorized-container">
                <div className="unauthorized-content">
                    <div className="unauthorized-logo">
                        <img src={logoText} alt="Workwise logo" />
                    </div>
                    <h2 className="unauthorized-title">Access required</h2>
                    <p className="unauthorized-text">
                        You are seeing this screen because you are not signed in, your session has expired, or you don't have permission to access this dashboard. To proceed, please sign in with your Workwise account.
                    </p>
                    <div className="unauthorized-actions">
                        <button
                            onClick={onLogin}
                            className="unauthorized-btn"
                            aria-label="Sign in to Workwise"
                        >
                            Workwise Login
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UnauthorizedView;
